import React from 'react';
import '../styles/theme.css';
import '../styles/Settings.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import SettingsMasthead from '../components/SettingsMasthead';
import SettingsActionStrip from '../components/SettingsActionStrip';
import SettingsConfigPanel from '../components/SettingsConfigPanel';
/* IMPORTS */

function SettingsPage() {
  return (
    <div className="se-root">
      <div className="se-layout-1">
        <div id="settingsheaderslot" className="se-slot-settingsheaderslot">
          <BruteHeader activePage={"Settings"} />
        </div>
        <div className="se-layout-2">
          <div id="settingsmasthead" className="se-slot-settingsmasthead">
            <SettingsMasthead />
          </div>
          <div id="settingsconfigpanel" className="se-slot-settingsconfigpanel">
            <SettingsConfigPanel />
          </div>
        </div>
        <div id="settingsactionstrip" className="se-slot-settingsactionstrip">
          <SettingsActionStrip />
        </div>
        <div id="settingsfooterslot" className="se-slot-settingsfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;